import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import Modal from 'react-modal'

import { Button } from 'components/base'

import { MODAL_DEFAULT_STYLE, MODAL_DEFAULT_CLASS } from './style'

export default function ConfirmationModal({
  cancelLabel,
  confirmLabel,
  CancelButtonComponent = Button.Secondary,
  ConfirmButtonComponent = Button.Danger,
  onConfirm,
  onCancel,
  onAfterOpen,
  children,
  show,
  width = 450,
}) {
  const style = {
    content: {
      ...MODAL_DEFAULT_STYLE.content,
      width,
      zIndex: 10,
    },
    overlay: {
      ...MODAL_DEFAULT_STYLE.overlay,
      zIndex: 9,
    },
  }

  return (
    <Modal
      style={style}
      isOpen={show}
      className={classNames(
        'modal-alert slite-design-system',
        'color-mode-elevated',
        MODAL_DEFAULT_CLASS
      )}
      onRequestClose={onCancel}
      onAfterOpen={onAfterOpen}
    >
      <div className="padding-larger center-text">
        <div className="line-height-large">{children}</div>
        <div className="flexbox margin-top-large">
          <CancelButtonComponent className="flexbox-grow" onClick={onCancel}>
            {cancelLabel}
          </CancelButtonComponent>
          <div className="margin-left-large" />
          <ConfirmButtonComponent
            className="flexbox-grow"
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </ConfirmButtonComponent>
        </div>
      </div>
    </Modal>
  )
}

ConfirmationModal.propTypes = {
  children: PropTypes.node.isRequired,
  cancelLabel: PropTypes.node.isRequired,
  confirmLabel: PropTypes.node.isRequired,
  confirmColorScheme: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onAfterOpen: PropTypes.func,
  show: PropTypes.bool.isRequired,
}

ConfirmationModal.defaultProps = {
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  confirmColorScheme: 'primary',
  onAfterOpen: () => {},
}
